import React, { Component } from "react";
import { Link } from "react-router-dom";
import { I18n } from "react-i18next";
import "../utils/i18n";
import "./Home.css";
import GoogleMapContainer from "../utils/GoogleMapContainer";
import { Marker } from "react-google-maps";
import { MarkerClusterer } from "react-google-maps/lib/components/addons/MarkerClusterer";
import api from "../api/api";

const initialState = {
  markers: []
};

const HomeTile = props => {
  return (
    <div className="span3">
      <Link to={props.to}>
        <div className="home-section">
          <div className="home-section-content">{props.children}</div>
          <div className="home-section-title">{props.title}</div>
        </div>
      </Link>
    </div>
  );
};
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }
  componentDidMount() {
    sessionStorage.removeItem("searchUnifiedState");
    sessionStorage.removeItem("rechercheState");

    try {
      // use try/catch to ensure Home will be loaded at any time
      api.geoLocations().subscribe(result => {
        this.setState({ markers: result.locations });
      });
    } catch (e) {
      console.error(e);
    }
  }

  render() {
    return (
      <I18n>
        {(t, { i18n }) => (
          <div>
            <div className="row title-row">
              <HomeTile
                title={t("navigation.Orgelsuche")}
                to="/search-unified/orgelsuche"
              >
                <img
                  src="images/startseite-orgel.jpg"
                  alt="Orgel Malters-Blatten"
                />
              </HomeTile>
              <HomeTile
                title={t("navigation.Orgelbauersuche")}
                to="/search-unified/orgelbauer"
              >
                <img
                  src="images/startseite-orgelbauer-victor-bossart.jpg"
                  alt="Victor Bossart"
                />
              </HomeTile>
              <HomeTile
                title={t("navigation.Kartensuche")}
                to="/search-unified/karte"
              >
                <GoogleMapContainer
                  googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAdmbcLZbNjruP22UpYEFrMwJH7-1HVoc0&v=3.exp&libraries=geometry,drawing,places"
                  loadingElement={<div style={{ height: `100%` }} />}
                  containerElement={<div style={{ height: `100%` }} />}
                  mapElement={<div style={{ height: `100%` }} />}
                  center={{ lat: 46.8, lng: 8.2 }}
                  zoom={6}
                  options={{
                    streetViewControl: false,
                    mapTypeControl: false,
                    scrollwheel: false,
                    zoomControl: false,
                    minZoom: 3,
                    maxZoom: 15
                  }}
                >
                  <MarkerClusterer
                    averageCenter
                    enableRetinaIcons
                    gridSize={30}
                  >
                    {this.state.markers.map(({ lat, lng, id }) => (
                      <Marker
                        position={{
                          lat: lat,
                          lng: lng
                        }}
                        key={id}
                      />
                    ))}
                  </MarkerClusterer>
                </GoogleMapContainer>
              </HomeTile>
              <HomeTile title={t("navigation.Recherche")} to="/recherche">
                <img
                  src="images/startseite-recherche1.jpg"
                  alt={t("navigation.Recherche")}
                />
              </HomeTile>
            </div>
            <div className="row home-title-row">
              <div className="span12">
                <p>
                  <strong>{t("startseite.Titel")}</strong>
                </p>
              </div>
            </div>
            <div className="row">
              <div className="span12">
                <p>{t("startseite.Intro1")}</p>
                <p>{t("startseite.Intro2")}</p>
                <p>{t("startseite.Intro3")}</p>
              </div>
            </div>
            <div className="row">
              <div className="span12">
                <p>{t("startseite.Intro4")}</p>
                <p>{t("startseite.Intro5")}</p>
                <p>{t("startseite.Intro6")}</p>
                <p>{t("startseite.Intro7")}</p>
                <p>
                  {t("startseite.Intro8")}
                  <br />
                  <a href="mailto:marco.brandazza@hslu.ch">
                    <span className="Stil3">{t("startseite.Intro9")}</span>
                  </a>
                </p>
              </div>
            </div>
          </div>
        )}
      </I18n>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/home/Home.js